<div class="display-post__wrapper">
    <button class="retour-button" (click)="goBack()">
      <span class="icon">&#8592;</span> Retour
    </button>
    <div class="display-post__title">
        <h1 style="text-transform: capitalize; flex: 1">{{post?.horse?.name}}</h1>

        <div>{{ "posts.fields.sold_by" | translate }}
          <span style="background-color: rgb(0, 100, 225); padding: 2px 5px; color: white; font-weight: 700; border-radius: 3px; margin-left:5px;">{{post?.contact?.lastName}} - {{post?.contact?.firstName}}</span>
          <br>
          <a href="mailto: {{post?.contact?.email}}">{{post?.contact?.email}}</a>
        </div>
    </div>

    <div class="display-post__infos">
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.sex" | translate }}</div>
            <div *ngIf="isMale()" class="data__value">{{ "post.horse.sex.male" | translate }}</div>
            <div *ngIf="isFemale()" class="data__value">{{ "post.horse.sex.female" | translate }}</div>
            <div *ngIf="isHongre()" class="data__value">{{ "post.horse.sex.gelding" | translate }}</div>
        </div>
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.category" | translate }}</div>
            <div *ngIf="!post?.category" class="data__value">aucune catégorie</div>
            <div *ngIf="post?.category" class="data__value">
              {{"posts.actions.create.fields.category.options." + (post?.category | lowercase) | translate }}
            </div>
        </div>
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.age" | translate }}</div>
            <div class="data__value">{{post?.horse?.birthYear}}</div>
        </div>
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.total_earn" | translate}}</div>
            <div class="data__value">{{post?.horse?.totalEarn  | euro }}</div>
        </div>
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.record" | translate }}</div>
            <div class="data__value">{{post?.horse?.raceRecord}}</div>
        </div>
    </div>
    <div class="display-post__infos">
<!--        <div class="infos__data">-->
<!--            <div class="data__title">{{ "posts.fields.father" | translate }}</div>-->
<!--            <div class="data__value">{{post?.horse?.father}}</div>-->
<!--        </div>-->
        <div class="infos__data">
          <div class="data__title">{{ "posts.fields.father" | translate }}</div>
          <div class="data__value">{{post?.horse?.father}}</div>
        </div>
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.mother" | translate }}</div>
            <div class="data__value">{{post?.horse?.mother}}</div>
        </div>
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.sell_price" | translate }}</div>
            <div class="data__value">{{ price() | euro }}</div>
        </div>
    </div>
    <div class="display-post__infos">
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.place" | translate }}</div>
            <div class="data__value">{{post?.horse?.location}}</div>
        </div>
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.contact" | translate }}</div>
            <div class="data__value">{{post?.contact?.lastName}}</div>
        </div>
        <div class="infos__data">
            <div class="data__title">{{ "posts.fields.language" | translate }}</div>
            <div *ngIf="post?.contact?.isEnglish" class="data__value">{{ "post.contact.isenglish.english" | translate }}</div>
            <div *ngIf="!post?.contact?.isEnglish" class="data__value">{{ "post.contact.isenglish.french" | translate }}</div>
        </div>
        <div class="infos__data" (click)="showPhoneNumber()">
            <div class="data__title">{{ "posts.fields.hidden_phone" | translate }}</div>
            <div class="data__value">{{hiddenPhoneNumber}}</div>
        </div>
    </div>
    <div *ngIf="getComment() !== null && getComment() !== ''" class="display-post__infos" style="margin-top:20px;">
        <div class="infos__text">
            <div class="data__title">{{ "posts.fields.comments" | translate }}</div>
            <div class="data__value">{{getComment()}}</div>
        </div>
    </div>

  <div class="docList" *ngIf="user?.moderator">
    <div *ngIf="post?.horseRegistration">
      <p-button label="Immatriculation" styleClass="p-button-text" (click)="getHorseRegistration()" class="docButton"></p-button>
    </div>
    <div *ngIf="post?.certificateOfSale">
      <p-button styleClass="p-button-text" icon="pi pi-external-link" label="Attestation vente" (click)="getCertificateOfSale()" class="docButton"></p-button>
    </div>
    <div *ngIf="post?.certificationOfThePerson">
      <p-button styleClass="p-button-text" icon="pi pi-external-link" label="Attestation personne" (click)="getCertificationOfThePerson()" class="docButton"></p-button>
    </div>
    <div *ngIf="post?.extractKbis">
      <p-button styleClass="p-button-text" icon="pi pi-external-link" label="Extrait Kbis" (click)="getExtractKbis()" class="docButton"></p-button>
    </div>
  </div>

  <div class="card md:flex md:justify-content-center" *ngIf="post?.photos">
    <div *ngIf="post?.photos" class="grid images">
      <div *ngFor="let image of post!.photos; let index = index" class="col-3" key="index">
        <div class="image" [ngStyle]="{ 'background-image': 'url(' + image + ')' }" (click)="imagePreview = true">
        </div>
      </div>
    </div>
    <p-galleria
      [value]="post!.photos"
      [(visible)]="imagePreview"
      [responsiveOptions]="responsiveOptions"
      [numVisible]="9"
      [circular]="false"
      [fullScreen]="true"
      [showItemNavigators]="true"
      [showThumbnails]="false">
      <ng-template pTemplate="item" let-item>
        <img [src]="item" style="width: 100%; display: block;" />
      </ng-template>
    </p-galleria>
  </div>



</div>
